/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NftRewardPrize } from './NftRewardPrize';
import {
    NftRewardPrizeFromJSON,
    NftRewardPrizeFromJSONTyped,
    NftRewardPrizeToJSON,
    NftRewardPrizeToJSONTyped,
} from './NftRewardPrize';

/**
 * 
 * @export
 * @interface RedeemNftRewardResponse
 */
export interface RedeemNftRewardResponse {
    /**
     * 
     * @type {NftRewardPrize}
     * @memberof RedeemNftRewardResponse
     */
    nftPrize: NftRewardPrize;
    /**
     * 
     * @type {string}
     * @memberof RedeemNftRewardResponse
     */
    promoName?: string;
    /**
     * 
     * @type {string}
     * @memberof RedeemNftRewardResponse
     */
    promoCode?: string;
    /**
     * 
     * @type {string}
     * @memberof RedeemNftRewardResponse
     */
    trackerName?: string;
}

/**
 * Check if a given object implements the RedeemNftRewardResponse interface.
 */
export function instanceOfRedeemNftRewardResponse(value: object): value is RedeemNftRewardResponse {
    if (!('nftPrize' in value) || value['nftPrize'] === undefined) return false;
    return true;
}

export function RedeemNftRewardResponseFromJSON(json: any): RedeemNftRewardResponse {
    return RedeemNftRewardResponseFromJSONTyped(json, false);
}

export function RedeemNftRewardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RedeemNftRewardResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'nftPrize': NftRewardPrizeFromJSON(json['nftPrize']),
        'promoName': json['promoName'] == null ? undefined : json['promoName'],
        'promoCode': json['promoCode'] == null ? undefined : json['promoCode'],
        'trackerName': json['trackerName'] == null ? undefined : json['trackerName'],
    };
}

export function RedeemNftRewardResponseToJSON(json: any): RedeemNftRewardResponse {
    return RedeemNftRewardResponseToJSONTyped(json, false);
}

export function RedeemNftRewardResponseToJSONTyped(value?: RedeemNftRewardResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nftPrize': NftRewardPrizeToJSON(value['nftPrize']),
        'promoName': value['promoName'],
        'promoCode': value['promoCode'],
        'trackerName': value['trackerName'],
    };
}

